import { Injectable } from '@angular/core';
import { EQimaSpinnerUnit } from '@qima/ngx-qima';

@Injectable({
  providedIn: 'root',
})
export class QimaSpinnerService {
  public readonly unit = EQimaSpinnerUnit;
}
